export enum CallTypeEnum {
    ALARM = 'Alarm',
    DBH = 'DBH',
    PHONE = 'Phone',
    TELEMATICS = 'Telematics',
    TEXT = 'Text',
    VOIP = 'VoIP',
    WIRELESS = 'Wireless',
    WIRELINE = 'Wireline'
}
